import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Boolean, String]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: String
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps
    }
  },
  created () {},
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  watch: {
    value(newValue) {
      this.$emit('input', newValue)
    }
  },
  methods: {
    onBlur () {}
  }
}
